import { observer } from 'mobx-react-lite';
import { CardPreview } from './CardPreview/CardPreview';
import { useTeachingBlockStore } from './Contexts/TeachingBlockContext';
import { GridHeader } from './GridHeader/GridHeader';
import { GridRows } from './GridRows/GridRows';
import { CardDurationModal } from './Modals/CardDurationModal/CardDurationModal';
import { CardRoomsModal } from './Modals/CardRoomsModal/CardRoomsModal';
import { ConflictModal } from './Modals/ConflictModal/ConflictModal';
import { TimeConflictModal } from './Modals/TimeConflictModal/TimeConflictModal';
import styles from './TeachingBlockGrid.module.scss';

export const TeachingBlockGrid = observer(() => {
  const store = useTeachingBlockStore();

  return (
    <div className={styles['teaching-block-grid']}>
      <GridHeader months={store.months} />
      <GridRows />
      {store.pickedCard && (
        <CardPreview pickedCard={store.pickedCard} preventEscape={store.timeConflictModal.isOpen ?? false} />
      )}
      <ConflictModal />
      <TimeConflictModal />
      <CardDurationModal />
      <CardRoomsModal />
    </div>
  );
});
